// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__wnhOb","header":"MergedInvoice_header__3m8A5"};